import { ActionResult, DirectoryItem } from '../types'
import { ExecutableAction } from './action'

async function navigateTo(tree, itemOrId: DirectoryItem | string): Promise<ActionResult<string>> {
  const targetId = typeof itemOrId === 'string' ? itemOrId : itemOrId.id
  const item = typeof itemOrId === 'string' ? tree.findNodeById(itemOrId) : itemOrId

  if (item?.id === 'error-file') {
    return {
      status: 'error',
      message: 'Clicked error file!'
    }
  }

  if (item?.type === 'directory') {
    return {
      status: 'success',
      data: targetId,
      update: {
        currentDirectoryId: targetId,
        refresh: true
      }
    }
  } else if (item) {
    if (item.type === 'link' && (tree.findNodeById(item.id) as DirectoryItem<'link'>)?.url) {
      // Also fetch full node for URL
      window.open((tree.findNodeById(item.id) as DirectoryItem<'link'>).url, '_blank')
      return {
        status: 'success',
        data: targetId,
        update: {
          refresh: false
        }
      }
    } else if (item.type === 'file') {
      // const fullFileNode = findNodeById(getRootNode(), item.id) as DirectoryItem<'file'> | null
      // const blobId = fullFileNode?.blobId
      // alert(`Opening file: ${item.name}\nBlob id: ${blobId}`)
      return {
        status: 'success',
        data: targetId,
        update: {
          refresh: false
        }
      }
    }
  } else {
    return {
      status: 'error',
      message: `Item with ID ${targetId} does not exist or is not a directory.`
    }
  }
  return {
    status: 'error',
    message: `Failed to navigate to item with ID ${targetId}.`
  }
}

export class OpenAction extends ExecutableAction<string> {
  static readonly actionName = 'open'
  public readonly actionName = OpenAction.actionName

  constructor(private readonly item: DirectoryItem) {
    super()
  }

  override async execute(tree): Promise<ActionResult<string>> {
    return navigateTo(tree, this.item.id)
  }

  override async undo(): Promise<ActionResult<string>> {
    return { status: 'success', data: '' }
  }
}
